import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc4e31fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4e31fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc4e31fe')) {
      api.createRecord('dc4e31fe', component.options)
    } else {
      api.reload('dc4e31fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dc4e31fe&scoped=true", function () {
      api.rerender('dc4e31fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/setting/basic/index.vue"
export default component.exports